import { NestedItem } from '../../../helpers/createNestedListFromStringList';
import findInNested from '../../../helpers/findInNested';
import { ApplicationState } from '../../types';
import { filterSelectors } from '../filter';
import { templateSelectors } from '../template';

export const selectCategoryListCount = ({ category }: ApplicationState) =>
  category.items.list.length;

export const selectCategoryList = ({ category }: ApplicationState) =>
  category.items.list;

export const selectCategoryFromList = (path = '') => ({
  category
}: ApplicationState) =>
  findInNested(category.items.list, item => item.path === path);

export const selectCategoriesCount = ({ category }: ApplicationState) =>
  category.items.count;

export const selectCategoryFilter = (state: ApplicationState) => {
  const { category } = filterSelectors.selectTemplatesFilters(state);
  return typeof category === 'string'
    ? category
    : templateSelectors.getTemplateItemsState(state).filters.category;
};

export const selectCategoryChildren = (categoryName: string) => ({
  category
}: ApplicationState) => {
  const list = category.items.list.find(item => item.name === categoryName);
  return list ? list.children : ([] as NestedItem[]);
};
